import axios from '@/axios/index'

// 获取列表
export function getList(data) {
  return axios({
    url: '/api/data/red/book/content/zq/list',
    method: 'post',
    data
  })
}

// 列表总数
export function getListTotal(data) {
  return axios({
    url: '/api/data/red/book/content/zq/list/total',
    method: 'post',
    data
  })
}

// 小红书内容数据详情接口
export function getDetailInfo(data) {
  return axios({
    url: '/api/data/red/book/content/zq/detail',
    method: 'post',
    data
  })
}

// 小红书内容数据新增接口
export function addContent(data = {}) {
  return axios({
    url: '/api/data/red/book/content/zq/add',
    method: 'post',
    data
  })
}

// 小红书内容数据修改接口
export function updateContent(data = {}) {
  return axios({
    url: '/api/data/red/book/content/zq/edit',
    method: 'post',
    data
  })
}

// 排序指标
export function getSortLabel() {
  return axios({
    url: '/api/label/data/back/index/zq/label',
    method: 'get'
  })
}

// 导出
export function getExportLabel(data = {}) {
  return axios({
    url: '/api/label/article/manual/zq/export/label',
    method: 'get',
    data
  })
}
